import {  useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Header from "../header/Header";
import Footer from "../footer/Footer";

const DeleteProfile = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

  const addDeleteRequest = async (e) => {
    e.preventDefault();

    if (!email.trim() || !name.trim() ) {
      toast.error("Please fill all fields.");
      return;
    }

    try {
      const formData = { 
        email,
        name,
        message
      };

      const response = await axios.post(
        `${base_url}/api/v1/users/delete-request`,
        formData,
      );

      console.log("Delete request response:", response.data.data);
      toast.success("Delete request sent successfully.");

      setEmail("");
      setName("");
      setMessage("");

    } catch (err) {
      console.error("Error sending delete request:", err);
      toast.error("Failed to send delete request.");
    }
  };

  return (
    <>
    <Header/>
     <div className="my-4" >
      <div className="container">
        <div className="row">
          <div className="col-md-6 mx-auto">
            <div className="card bg-light shadow-sm">
              <div
                className="card-header text-white"
                style={{ backgroundColor: "#085f9a" }}
              >
                Delete Profile Request
              </div>

              <div className="card-body">
                <form onSubmit={addDeleteRequest}>
                  
                  <div className="form-group">
                    <label>Your Name <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter your name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>

                  <div className="form-group mt-3">
                    <label>Your Registered Phone Number or Email <span className="text-danger">*</span></label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Your Registered Phone Number or Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="form-group mt-3">
                    <label>Reason for Account Deletion (Optional)</label>
                    <textarea
                      className="form-control"
                      placeholder="Write your reason"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                  </div>

                  <button
                    type="submit"
                    className="btn text-white mt-3"
                    style={{ backgroundColor: "#085f9a" }}
                  >
                    Submit Request
                  </button>

                </form>
              </div>

            </div>
          </div>
        </div>
    </div>
     </div>
    <Footer/>
    </>
  );
};

export default DeleteProfile;